import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { Subject } from 'rxjs';
import { GeoCastingResult } from 'src/app/models/WebServer/geoCastingResult';
import Swal from 'sweetalert2';
// import { AgmMap } from '@agm/core';
import { Store } from '@ngrx/store';
import { Constants } from 'src/app/constants';
import { CoordsClone, CoordsToGMaps, GeoLocCoords } from 'src/app/models/coordinates';
import { AppModesEnum } from 'src/app/models/WebServer/appModesEnum';
import { AppConfigService } from 'src/app/services/app.config.service';
import { FELoggerService, LogSource } from 'src/app/services/feLogger.service';
import { GeoCastingService } from 'src/app/services/geocasting.service';
import { I18Service } from 'src/app/services/i18.service';
import * as appActions from "src/app/store/actions/app.actions";
import * as sessionStatusActions from "src/app/store/actions/sessionStatus.actions";
import { RootState } from 'src/app/store/root.state';
import { AppState } from 'src/app/store/states/app.state';

import { GoogleMap } from '@angular/google-maps';
import { AppHelper } from 'src/app/helpers/app.helper';
import { BrowserHelper } from 'src/app/helpers/browser.helper';
import { StatusChangeEvent } from 'src/app/models/statusChangeEvent';
import { AddressInfo } from 'src/app/models/WebServer/addressInfo';
import { PartecipantStatus } from 'src/app/models/WebServer/partecipantStatus';
import { EventService } from 'src/app/services/event.service';
import { NotificationService } from 'src/app/services/notification.service';

const MIN_POSITION_DISPATCH_TIME_SECS = 5;
const INITIAL_ZOOM_LEVEL = 6.5;
const DISTANCE_THRESHOLD = 10;

const GEO_OPTIONS: PositionOptions = {
  enableHighAccuracy: true,
  maximumAge: 9000,
  timeout: 10000
}
    

@Component({
  selector: 'app-position-manager',
  templateUrl: './position-manager.component.html',
  styleUrls: ['./position-manager.component.scss'],
})
export class PositionManagerComponent implements AfterViewInit, OnDestroy {
  @ViewChild('mapContainer') mapContainer!: GoogleMap;

  @Input() AS!: AppState;
  @Input() MYSTATUS?: PartecipantStatus;

  watchId?: number;

  // variabili di stato
  appModes = AppModesEnum;
  sendPosition = true;
  subscribedToGoolge = false;
  firstRegistration = true;
  sendingEvent = false;
  firstSend = false;
  connectionStatus = 'redStatus';
  expirationWarning = 0;
  zoomLevel = INITIAL_ZOOM_LEVEL;
  constants = Constants;

  // variabili sensori e servizi
  geoCastingResult: GeoCastingResult | undefined;
  resizedSize: number | undefined;
  lastGeoCastLat: number | undefined;
  lastGeoCastLog: number | undefined;
  fileReader: FileReader | undefined;
  mapInfo: string = '';
  
  currentLocation: GeoLocCoords = { latitude: Constants.DEFAULT_LATITUDE, longitude: Constants.DEFAULT_LONGITUDE };
  mapCenter: google.maps.LatLngLiteral = {lat: Constants.DEFAULT_LATITUDE, lng: Constants.DEFAULT_LONGITUDE};


  currentAddress?: AddressInfo;
  message!: string;
  status!: string;

  // performance variables
  elapsedSendEvent!: number;
  elapsedSendEventMedia!: number;
  elapsedKamailioConnection!: number;

  permissionValue: number = -1;

  private destroy$: Subject<boolean> = new Subject<boolean>();

  title = AppHelper.getTitleName();
  constructor(
    private eventService: EventService,
    private store: Store<RootState>,
    public config: AppConfigService,
    private geoCastingService: GeoCastingService) { }

  ngOnDestroy(): void {
    console.log(`position-manager: ngOnDestroy`)
    this.destroy$.next(true);
    this.destroy$.complete();
    this.destroy$.unsubscribe();

    if (window.navigator && this.watchId) {
      window.navigator.geolocation.clearWatch(this.watchId);
    }
  }

  ngAfterViewInit() {
    this.setEventSubscription();
  }

  setEventSubscription() {

    if (this.config.isCaller && this.config.sessionConfig?.localization) {
      this.informAboutOwnPermission('geolocation');
      this.getPosition();
    }
  }


  onMapReady(map?: google.maps.Map) {
    console.log(`position: map ready`, map)
    if (!map) return;
    map.setOptions({
      streetViewControl: false,
      fullscreenControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      zoomControl: true
    });
    map.addListener("click", (event: google.maps.MapMouseEvent) => {
      const e = event as google.maps.IconMouseEvent; // <— cast

      if (e.placeId) {
        event.stop();        // blocca l'InfoWindow automatico
        return;              // non fare altro
      }
    });

    // Crea dinamicamente il bottone reset e lo aggiunge ai controlli di Google Maps
    const controlDiv = document.createElement('div');
    controlDiv.style.marginRight = '10px';
    controlDiv.style.marginBottom = '10px';

    controlDiv.innerHTML = `
      <button style="
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: none;
        background-color: #fff;
        box-shadow: 0 2px 6px rgba(0,0,0,0.3);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: box-shadow 0.2s;
        padding: 0;
      "
      onmouseover="this.style.boxShadow='0 4px 8px rgba(0,0,0,0.4)'"
      onmouseout="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.3)'"
      title="${I18Service.get('LABELS.RESETMAPPOSITION')}">
        <span class="material-symbols-outlined" style="font-size: 20px; color: #666;">my_location</span>
      </button>
    `;

    const button = controlDiv.querySelector('button');
    button?.addEventListener('click', () => {
      this.resetMapPosition();
    });

    map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
  }

  resetMapPosition() {
    if (this.mapContainer?.googleMap) {
      this.mapContainer.googleMap.setCenter(this.mapCenter);
      this.mapContainer.googleMap.setZoom(this.zoomLevel);
    }
  }


  private geoCasting(latitude: string, longitude: string): Promise<AddressInfo | null> {
    return new Promise<AddressInfo | null>(resolve => {
      // if (this.lastGeoCastLog != +longitude && this.lastGeoCastLat != +latitude) {
      //   this.lastGeoCastLog = +longitude;
      //   this.lastGeoCastLat = +latitude;
      const self = this;
      self.geoCastingService.geoCastingBackEnd(latitude, longitude).subscribe({
        next: (ai) => {

          resolve(ai);

        },
        error: (err) => {
          FELoggerService.error(`GeoCasting Fallito`, LogSource.StartGeoLocationTracking, err);
          resolve(null)
        }
      });
    })
  }

  private async getPosition() {
    console.log(`startGeoLocationTracking getPosition watchId: ${this.watchId}`)
    // const self = this;
    let geoTimeOut = this.config.geoPermissionTimeout || 60000;
    GEO_OPTIONS.maximumAge = geoTimeOut - 1000;
    GEO_OPTIONS.timeout = geoTimeOut;
    // var location_timeout: any;

    // if (!this.watchId) {

    //   location_timeout = setTimeout(() => {
    //     if (this.watchId) return;
    //     this.handleGeoError({ code: GeolocationPositionError.TIMEOUT, message: 'Position acquisition timed out' })
    //   }, (geoTimeOut - 1000));

    //   console.log(`startGeoLocationTracking setting timeout for geo location: ${location_timeout}`);
    // }

    const options: PositionOptions = {
      enableHighAccuracy: true,
      maximumAge: Infinity,
      timeout: 10000
    }

    navigator.geolocation.getCurrentPosition( 
      (position) => {
      Swal.close();
      const actual: GeoLocCoords = CoordsClone(position.coords);
      this.currentLocation = actual;
      this.mapCenter = CoordsToGMaps(actual);
      console.log(`startGeoLocationTracking getPosition found: `, actual)
      
      this.setPermission('geolocation', 1);
      
      this.startGeoLocationTracking();
    }, (err: GeolocationPositionError) => {
      this.handleGeoError(err);
    }, GEO_OPTIONS);
  }

  private async startGeoLocationTracking() {
    console.log(`startGeoLocationTracking watchId: ${this.watchId}`)
    if (this.watchId) {
      console.log(`startGeoLocationTracking - already watching????!!!`)
      return;
    }
   

    var firstSend = true;
    let timePassedAfterAcceptance = new Date().getTime();

    this.watchId = navigator.geolocation.watchPosition(
      (position: GeolocationPosition) => {
        var elapsed = new Date().getTime() - timePassedAfterAcceptance;
        const minAccuracy = this.config?.agencySettings?.minAccuracy || 0;
        const sendPositionThreshold = this.config?.agencySettings?.sendPositionThreshold || 20000;

        const actual: GeoLocCoords = CoordsClone(position.coords);

        const distance = this.getDistanceFromLatLon(actual, this.currentLocation);
        if (firstSend && (position.coords.accuracy <= minAccuracy || elapsed >= sendPositionThreshold) || distance > DISTANCE_THRESHOLD) {
          console.log(`GeoLocationTracking watching watchid: ${this.watchId}`, actual);
          // this.eventService.saveBusinessEvent(BusinessEventTypes.FirstLocationSend,
          //   { elapsed: elapsed, accuracy: position.coords.accuracy, sendForTimeout: elapsed >= sendPositionThreshold }).subscribe();
          this.sendUpdateLocation(actual);
          firstSend = false;
        }
      },
      (err) => {
        this.handleGeoError(err);
      },
      GEO_OPTIONS);

  }

  handleGeoError(error: GeolocationPositionError | { code: number, message: string }, popup: boolean = true) {
    //Display error based on the error code.
    console.error(error);
    FELoggerService.error(`ERROR WITH GEOLOCATION watchId:${this.watchId} --> CODE:`, LogSource.StartGeoLocationTracking, error);//, Framework.Localization);
    const { code } = error;
    switch (code) {
      //TIMEOUT
      case 3:
        if (popup) {
          // NotificationService.popupInfo({msg:I18Service.get('SA.TIMEOUTGLBODY'), confirmButton:I18Service.get('SA.TIMEOUTGLBTN')})
          this.store.dispatch(appActions.gpsProblems({ hasProblems: true }));
          NotificationService.showError(I18Service.get('SA.TIMEOUTGLBODY'));
          setTimeout(() => {
            this.newGeoAttempt();
          }, 10000);
        }
        break;
      //DENIED
      case 1:
        this.setPermission('geolocation', 2);
        if (popup) {
          NotificationService.popupWarn({msg:I18Service.get('SA.DENIEDGLBODY'), confirmButton:I18Service.get('SA.TIMEOUTGLBTN')})
          .then((result: any) => {
            if (result?.isConfirmed) this.geoAttemptByReloading();
          });
        }
        break;
      //POSITION_UNAVAILABLE
      case 2:
      default:
        if (popup) {
          NotificationService.popupWarn({msg:I18Service.get('SA.UNAVAILABLEGLBODY'),confirmButton:I18Service.get('SA.TIMEOUTGLBTN')})
            .then(() => {
              this.newGeoAttempt();
          });
        }
        break;
    }
  }

  async newGeoAttempt() {
    // await this.informAboutOwnPermission('geolocation');
    console.log(`GeoLocationTracking newGeoAttempt watchId: ${this.watchId}`);

    if (window.navigator && this.watchId) {
      window.navigator.geolocation.clearWatch(this.watchId);
      this.watchId = undefined;
    }

    NotificationService.timedToastWarn(I18Service.get('SA.GLNEWATTEMPT'), undefined, 2000, 'top', 'min(80dvw, 80vw)')
    .then(() => {
      this.getPosition();
    });
  }

  private geoAttemptByReloading() {
    // Send here notification to CAD
    NotificationService.timedToastWarn(I18Service.get('SA.GLRELOADATTEMPT'), undefined, 1500, 'top', 'min(80dvw, 80vw)')
    .then(() => {
      window.location.reload();
    });
  }

  async geoLocationError(errCode: number = 0, errMessage: string = '') {
    setTimeout(async () => {
      let title = I18Service.get('POPUP.GEOERRORBODY');
      let message = I18Service.get('POPUP.NAVIGATORNOTEXISTS');
      title = title ? title : 'Impossibile inviare la posizione';
      message = message ? message : `Non siamo in grado di leggere la tua posizione. Per favore prova a ricaricare la pagina`;
      FELoggerService.error(`Impossibile leggere la posizione: '${errMessage}'`, LogSource.Localization);
      NotificationService.popupWarn({msg:message, confirmButton:I18Service.get('SA.TIMEOUTGLBTN')});
    }, 5000);
  }

  private alreadySendingLocation = false;
  async sendLocationImmediately(snackbar: boolean = true) {
    if (this.alreadySendingLocation) return;
    this.alreadySendingLocation = true;
    // console.log(`sendLocationImmediately ***************************`)
    await this.informAboutOwnPermission('geolocation');
    const options = {
      enableHighAccuracy: true,
      maximumAge: Infinity
    };

    navigator.geolocation.getCurrentPosition((pos: GeolocationPosition) => {
      const actual: GeoLocCoords = CoordsClone(pos.coords);
      this.sendUpdateLocation(actual);
      this.alreadySendingLocation = false;
      if(snackbar && this.permissionValue == 1) {
        NotificationService.showSuccess(I18Service.get(`SNACKBAR.POSITIONSENT`));
      }
      if (snackbar && this.permissionValue != 1) {
        this.handleGeoError({code: 1, message:'Permission removed'});
      }
    }, (err: GeolocationPositionError) => {
      this.alreadySendingLocation = false;
      this.handleGeoError(err);
    }, options);

  }

  async sendCurrentLocation() { 
    await this.informAboutOwnPermission('geolocation');
    this.sendUpdateLocation(this.currentLocation); 
  }

  private sendUpdateLocation(position: GeoLocCoords) {

    if (this.zoomLevel == INITIAL_ZOOM_LEVEL) this.zoomLevel = 13; //al primo send.. zooma 

    if (this.permissionValue != 1) {
      NotificationService.showError(I18Service.get('SA.DENIEDGLTITLE'));
      return;
    }
    this.store.dispatch(appActions.gpsProblems({ hasProblems: false }));
    //evita richiesta di geoCast se coord non cambiano
    const distance = this.getDistanceFromLatLon(position, this.currentLocation);
    console.log(`GeoLocationTracking - sendUpdateLocation distance: ${distance} < ${DISTANCE_THRESHOLD}`, position);
    
    if (this.currentAddress && distance < DISTANCE_THRESHOLD) { // se distanza inferiore non richiede geocast
      this.dispatchPosition(position, this.currentAddress);
      return
    }
    this.currentLocation = position;
    
    if (!this.userInteractedWithMap) { //#84602
      this.mapCenter = CoordsToGMaps(position);
    }

    this.geoCasting(position.latitude + '', position.longitude + '').then((ai) => {
      console.log(`GeoLocationTracking - geocasting`, ai);
      if (ai) this.currentAddress = ai;
      this.dispatchPosition(position, ai);
    });
  }


  async informAboutOwnPermission(permissionName: PermissionName) {

    if (navigator.permissions ) {
      try {
        var permissionStatus = await navigator.permissions.query({ name: permissionName });

        console.debug(`informAboutOwnPermission ${permissionName} ${permissionStatus.state}`, permissionStatus);//, Framework.Localization);
        var permissionValue = 0; // 'prompt'

        if (permissionStatus.state == 'granted') {
          permissionValue = 1
        } else if (permissionStatus.state == 'denied') {
          permissionValue = 2
        }
        
         if(permissionValue == 0 && (BrowserHelper.isSafari() )) {
          // safari restituisce sempre prompt (a meno di non dare un ok complessivo)
          // filtriamo questi casi in modo da non avere sorprese
        }
        else {
          this.setPermission(permissionName, permissionValue);
        }

      }
      catch (error) {
        FELoggerService.error(`Unable to check '${permissionName}' permission in this browser`, LogSource.StartGeoLocationTracking, error);
        this.setPermission(permissionName, 0);
      }
    }
    // }
  }

  setPermission(permissionName: PermissionName, status: number) {

    if(this.permissionValue === status) return;
    console.log(`setPermission ${permissionName} => ${status}`)
    this.permissionValue = status;

    switch (permissionName) {
      case "geolocation":
        this.store.dispatch(sessionStatusActions.evt_changeStatus({ evt: StatusChangeEvent.GeoPermissionUpdated, val: status }))
        break;
      default:
        break;
    }
  }

  // manageUnregistration() {
  // }

  
  // checkSessionExpiration(): boolean { // spostato sul checkerService
  //   return false;
  // }

  setMessage(message: string) {
    this.message = message;
  }

  lastDispatch = 0;
  private dispatchPosition(position: GeoLocCoords, ai: AddressInfo | null) {

    const now = new Date().getTime();

    if (now < this.lastDispatch + 1000 * MIN_POSITION_DISPATCH_TIME_SECS) {
      //filtra i dispatch inferiori di 5 secondi
      return;
    }
    this.lastDispatch = now;

    const multiStatus = [
      { evt: StatusChangeEvent.GeoLocCoords, val: position },
      { evt: StatusChangeEvent.AddressInfo, val: ai },
      // { evt: StatusChangeEvent.IsRegistered, val: this.AS.isRegistered}
    ]
    this.store.dispatch(sessionStatusActions.evt_changeStatus({ evt: StatusChangeEvent.MultipleUpdateStatus, val: multiStatus }));
  }


  private getDistanceFromLatLon(pos1: GeoLocCoords, pos2: GeoLocCoords): number {
    const lat1 = pos1.latitude, lat2 = pos2.latitude, lon1 = pos1.longitude, lon2 = pos2.longitude;
    const R = 6371 * 1000; // Radius of the earth in m
    const dLat = this.deg2rad(lat2-lat1);  // deg2rad below
    const dLon = this.deg2rad(lon2-lon1); 
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
      Math.sin(dLon/2) * Math.sin(dLon/2)
      ; 
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    const d = R * c; // Distance
    return d;
  }
  
  private deg2rad(deg: number): number {
    return deg * (Math.PI/180)
  }


  userInteractedWithMap = false;
  onUserInteraction() {
    this.userInteractedWithMap = true;
  }

  // @ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow;
  // infoData = {
  //   title: '',
  //   address: ''
  // };
  // openInfoWindow(marker: MapMarker) {
  //   this.infoWindow.open(marker);
  // }

}
